export default {
  CUSTOMER_USER: {
    name: 'customer',
  },
};



// WEBPACK FOOTER //
// ./src/api/constants.js